import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { gray100 } from '../../constants/colors';
import MypageCompleteCard from '../uiParts/MypageCompleteCard';
import CustomSnackbar from '../uiParts/CustomSnackbar';
import SideBar from '../uiParts/SideBar';
import { sideBarWidth, spHeaderHeight } from '../../constants/location';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/auth';
import MetaTitle from '../utils/MetaTitle';

const styles = {
  page: {
    height: '100vh',
    display: 'flex',
    '@media (max-width: 960px)': {
      flexDirection: 'column',
      paddingTop: '0',
      justifyContent: 'flex-start',
    },
  },
  sidebar: {
    backgroundColor: gray100,
    height: '100vh',
    position: 'fixed',
    width: sideBarWidth,
    '@media screen and (max-width:960px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '18vh',
    backgroundColor: '#FBFBFB',
    marginLeft: sideBarWidth,
    width: '-webkit-fill-available',
    '@media (max-width: 960px)': {
      marginTop: spHeaderHeight,
      height: 'auto',
      alignItems: 'flex-start',
      marginLeft: 0,
    },
    '@media (max-width: 600px)': {
      paddingTop: '50%',
    },
  },
};

const StaffInviteComplete: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const { user, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);

      // ブラウザバックを無効化
      window.history.pushState(null, '', window.location.href);
    };

    // 初回ロード時にブラウザバックを無効化
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isLoading) return;
    // 未ログイン状態の場合はログイン画面へ遷移
    if (user === null) navigate('/');
  }, [user, isLoading]);

  return (
    <>
      <MetaTitle />
      <Box sx={styles.page}>
        <Box sx={styles.sidebar}>
          <SideBar />
        </Box>
        <Box sx={styles.container}>
          <MypageCompleteCard
            IconComponent={MailOutlineIcon}
            titleText={'ご登録メールアドレスに\n認証メールを送信しました'}
            messageText={
              'まだ担当者の追加は完了していません。\nお送りしたメールの内容に従って登録してください。\n有効期限を過ぎた場合は、管理者へ再招待を依頼してください。'
            }
            buttonText="担当者一覧へ"
            targetPath="/staff"
          />
        </Box>
      </Box>
      <CustomSnackbar
        autoHideDuration={6000}
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text={'前のページに戻れません。'}
      />
    </>
  );
};

export default StaffInviteComplete;
